/**
 * Returns true if the subject is undefined
 * @param subject
 */
export default function isUndefined(subject) {
    return subject === undefined;
}
